import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Team } from '../models/team';

@Injectable({
  providedIn: 'root'
})
export class TeamService {
  public teamsCount = signal<number>(0);

  constructor(
    private httpClient: HttpClient,
  ) { }

  // set teams count signal
  public setTeamsCount(value: number) {
    this.teamsCount.set(value);
  }

  // [GET] tournament teams
  public getTournamentTeams(tournamentId: string, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    const apiEndpoint = _.reduce(
      [[':type', type], [':tournament', tournamentId]],
      (res, [key, replacement]) => _.replace(res, key!, replacement!),
      environment.api_endpoints.tournamentTeams
    );
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + apiEndpoint, {
        params: {}, observe: 'response'
      });
  }

  // [POST] create team
  public createTeam(team: Team): Observable<{ [index: string]: any; }> {
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + environment.api_endpoints.teams, team, {
        params: {}, observe: 'response'
      });
  }

  // [PATCH] update team
  public updateTeam(team: Team): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
      (environment.api_server + `${environment.api_endpoints.teams}/${team.id}`, team, {
        params: {}, observe: 'response'
      });
  }

  // [DELETE] delete team
  public deleteTeam(team: Team): Observable<{ [index: string]: any; }> {
    return this.httpClient.delete<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.teamsDelete, ':id', team.id || ''),  
      { params: {}, observe: 'response' });
  }
}
